import { api } from '@/api/client'

export type ResolvedModule = {
  key: string
  name?: string
  description?: string | null
  group?: string | null
  enabled: boolean
  limits: Record<string, number>
  effectiveLimits: Record<string, number>
  source: 'override' | 'plan' | 'default'
  expiresAt: string | null
  catalogDefaultEnabled?: boolean
}

export type ModulesResponse = {
  modules: ResolvedModule[]
  enabledKeys: string[]
  tenantType: string
}

type ModulesApiRow = {
  key: string
  name?: string
  description?: string | null
  group?: string | null
  enabled: boolean
  limits: Record<string, number>
  effective_limits?: Record<string, number>
  source: string
  expires_at: string | null
  catalog_default_enabled?: boolean
}

type ModulesApiPayload = {
  modules: ModulesApiRow[]
  enabled_keys?: string[]
  tenant_type?: string
}

/**
 * Tenant admin panel'in aktif modüllerini getirir.
 * GET /api/v1/admin/me/modules
 */
export async function fetchAdminModules(): Promise<ModulesResponse> {
  const { data } = await api.get<{ data: ModulesApiPayload }>('/admin/me/modules')
  const raw = data.data
  const modules: ResolvedModule[] = (raw.modules ?? []).map((m) => ({
    key: m.key,
    name: m.name,
    description: m.description,
    group: m.group,
    enabled: m.enabled,
    limits: m.limits ?? {},
    effectiveLimits: m.effective_limits ?? {},
    source: m.source as ResolvedModule['source'],
    expiresAt: m.expires_at ?? null,
    catalogDefaultEnabled: m.catalog_default_enabled,
  }))
  return {
    modules,
    enabledKeys: raw.enabled_keys ?? [],
    tenantType: raw.tenant_type ?? 'store',
  }
}
